import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { GenericResponseDto } from '../models/generic-response.dto';
import { FileUploadDto } from '../models/shared/fileUploadDto';

@Injectable({
  providedIn: 'root'
})
export class PoEmailAttachmentsService {
  private fileManagementBaseURL = environment.baseUrl + '/fileManagement';
  constructor(private _http: HttpClient) {}

  getPoEmailAttachmentUrl(
    fileObj: FileUploadDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      this.fileManagementBaseURL + '/upload',
      fileObj
    );
  }
}
